"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _CmsLayout = _interopRequireDefault(require("../components/CmsLayout"));

var _TermForm = _interopRequireDefault(require("../components/forms/TermForm"));

var _ListItem = _interopRequireDefault(require("../components/ListItem"));

var _LanguageSelector = _interopRequireDefault(require("../components/LanguageSelector"));

var _utils = require("../utils");

var _redux = require("../redux"); // import app components


var Taxonomy = function Taxonomy(props) {
  var _site$taxonomies, _site$languages, _site$languages$taxon, _fields$taxonomies, _fields$taxonomies$fi;

  var taxonomyID = props.taxonomyID,
      fields = props.fields;

  var _ref4 = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      _ref4$cms = _ref4.cms,
      site = _ref4$cms.site,
      activeLanguage = _ref4$cms.activeLanguage;

  var dispatch = (0, _redux.useAppDispatch)();

  var _ref5 = (0, _react.useState)(null),
      _ref6 = _slicedToArray(_ref5, 2),
      loading = _ref6[0],
      setLoading = _ref6[1];

  var taxonomy = site === null || site === void 0 ? void 0 : (_site$taxonomies = site.taxonomies) === null || _site$taxonomies === void 0 ? void 0 : _site$taxonomies[taxonomyID];
  var terms = (taxonomy === null || taxonomy === void 0 ? void 0 : taxonomy.terms) && Object.values(taxonomy.terms);
  var hasTemplate = !!(fields !== null && fields !== void 0 && fields.taxonomies.find(function (o) {
    return o.id === taxonomyID;
  }).component); // Check if taxonomy supports languages

  var taxonomySupportsLanguages = !!(site !== null && site !== void 0 && (_site$languages = site.languages) !== null && _site$languages !== void 0 && (_site$languages$taxon = _site$languages.taxonomies) !== null && _site$languages$taxon !== void 0 && _site$languages$taxon.find(function (s) {
    return s === taxonomyID;
  })); // Check if there are untranslated taxonomies

  var taxonomiesWithoutLanguage = taxonomySupportsLanguages && terms.find(function (o) {
    return !o.language;
  }); // Filter by language

  var termsPerLanguage = taxonomySupportsLanguages ? terms.filter(function (o) {
    return activeLanguage === 'all' ? o : o.language === activeLanguage;
  }) : terms;
  var treeTerms = termsPerLanguage ? (0, _utils.createDataTree)(termsPerLanguage) : [];

  var handleSync = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading({
                action: 'syncing'
              });
              _context.next = 3;
              return dispatch(_redux.siteActions.syncFields({
                fields: fields,
                apiKey: (site === null || site === void 0 ? void 0 : site.apiKey) || ''
              }));

            case 3:
              setLoading(null);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSync() {
      return _ref7.apply(this, arguments);
    };
  }();

  var handleTranslateMass = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _site$languages2, language;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading({
                action: 'translate'
              });
              language = activeLanguage !== 'all' ? activeLanguage : (site === null || site === void 0 ? void 0 : (_site$languages2 = site.languages) === null || _site$languages2 === void 0 ? void 0 : _site$languages2.defaultLanguage) || '';
              _context2.next = 4;
              return dispatch(_redux.languageActions.translateMass({
                type: 'term',
                ids: terms.filter(function (o) {
                  return !o.language;
                }).map(function (o) {
                  return o.id;
                }),
                language: language
              }));

            case 4:
              setLoading(null);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleTranslateMass() {
      return _ref8.apply(this, arguments);
    };
  }();

  var handleUpsert = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref) {
      var id, title, slug, parentID, description, language;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              id = _ref.id, title = _ref.title, slug = _ref.slug, parentID = _ref.parentID, description = _ref.description, language = _ref.language;

              if (!id) {
                _context3.next = 6;
                break;
              }

              _context3.next = 4;
              return dispatch(_redux.termActions.updateTerm({
                taxonomyID: taxonomyID,
                id: id,
                title: title,
                slug: slug,
                parentID: parentID,
                description: description,
                language: language
              }));

            case 4:
              _context3.next = 8;
              break;

            case 6:
              _context3.next = 8;
              return dispatch(_redux.termActions.addTerm({
                taxonomyID: taxonomyID,
                title: title,
                slug: slug,
                parentID: parentID,
                description: description,
                language: language
              }));

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleUpsert(_x) {
      return _ref9.apply(this, arguments);
    };
  }();

  var handleDelete = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref2) {
      var termID;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              termID = _ref2.termID;
              setLoading({
                action: 'delete',
                id: termID
              });
              _context4.next = 4;
              return dispatch(_redux.termActions.deleteTerm({
                taxonomyID: taxonomyID,
                id: termID
              }));

            case 4:
              setLoading(null);

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleDelete(_x2) {
      return _ref10.apply(this, arguments);
    };
  }();

  var handleOpenDialog = function handleOpenDialog() {
    var term = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    dispatch(_redux.uiActions.showDialog({
      open: true,
      title: "Term",
      component: /*#__PURE__*/_react.default.createElement(_TermForm.default, (0, _extends2.default)({}, term, {
        taxonomyID: taxonomyID,
        terms: terms,
        onSubmit: handleUpsert
      }))
    }));
  };

  var handleEditTranslation = function handleEditTranslation(term, language) {
    if (term.language === language) {
      handleOpenDialog(term);
    } else if (term.translations[language]) {
      var translatedTerm = terms.find(function (o) {
        return o.id === term.translations[language];
      });
      handleOpenDialog(translatedTerm);
    }
  };

  var handleTranslateTerm = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref3) {
      var id, language, result;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              id = _ref3.id, language = _ref3.language;
              _context5.next = 3;
              return dispatch(_redux.termActions.translateTerm({
                id: id,
                language: language
              }));

            case 3:
              result = _context5.sent;
              handleOpenDialog(result);

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleTranslateTerm(_x3) {
      return _ref11.apply(this, arguments);
    };
  }();

  var renderUntranslatedTermsWarning = function renderUntranslatedTermsWarning() {
    var _site$languages3, _site$languages4, _site$languages4$lang;

    var languageSlug = activeLanguage !== 'all' ? activeLanguage : site === null || site === void 0 ? void 0 : (_site$languages3 = site.languages) === null || _site$languages3 === void 0 ? void 0 : _site$languages3.defaultLanguage;

    if (!languageSlug) {
      return null;
    }

    var languageName = site === null || site === void 0 ? void 0 : (_site$languages4 = site.languages) === null || _site$languages4 === void 0 ? void 0 : (_site$languages4$lang = _site$languages4.languages.find(function (o) {
      return o.slug === languageSlug;
    })) === null || _site$languages4$lang === void 0 ? void 0 : _site$languages4$lang.name;
    return /*#__PURE__*/_react.default.createElement(_antd.Alert, {
      message: "There are terms without a language",
      type: "info",
      showIcon: true,
      action: /*#__PURE__*/_react.default.createElement(_antd.Button, {
        size: "small",
        type: "ghost",
        onClick: handleTranslateMass,
        loading: (loading === null || loading === void 0 ? void 0 : loading.action) === 'translate'
      }, "Translate to ", languageName)
    });
  };

  var renderTerm = function renderTerm(o, level) {
    var actions = [];
    var slug = (0, _utils.generateSlug)({
      site: site,
      taxonomyID: o.taxonomyID,
      termID: o.id,
      leadingSlash: true
    });
    actions.push( /*#__PURE__*/_react.default.createElement(_antd.Popconfirm, {
      title: "Are you sure?",
      onConfirm: function onConfirm() {
        return handleDelete({
          termID: o.id
        });
      },
      okText: "Yes",
      cancelText: "No"
    }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
      size: "small",
      children: "Delete",
      loading: (loading === null || loading === void 0 ? void 0 : loading.id) === o.id && (loading === null || loading === void 0 ? void 0 : loading.action) === 'delete',
      danger: true
    })));
    actions.push( /*#__PURE__*/_react.default.createElement(_antd.Button, {
      size: "small",
      children: "Edit",
      onClick: function onClick() {
        return handleOpenDialog(o);
      }
    })); // if (hasTemplate) {
    //   actions.push(
    //     <Link to={slug}>
    //       <Button size="small" children="View" />
    //     </Link>
    //   );
    // }

    if (taxonomySupportsLanguages && o.language) {
      actions.unshift( /*#__PURE__*/_react.default.createElement(_LanguageSelector.default, {
        post: o,
        onTranslate: handleTranslateTerm,
        onEdit: function onEdit(language) {
          return handleEditTranslation(o, language);
        }
      }));
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: o.id
    }, /*#__PURE__*/_react.default.createElement(_ListItem.default, {
      level: level,
      actions: actions,
      title: o.title,
      subtitle: slug
    }), o.childNodes.map(function (p) {
      return renderTerm(p, level + 1);
    }));
  };

  return /*#__PURE__*/_react.default.createElement(_CmsLayout.default, {
    fields: fields,
    pageTitle: (fields === null || fields === void 0 ? void 0 : (_fields$taxonomies = fields.taxonomies) === null || _fields$taxonomies === void 0 ? void 0 : (_fields$taxonomies$fi = _fields$taxonomies.find(function (o) {
      return o.id === taxonomyID;
    })) === null || _fields$taxonomies$fi === void 0 ? void 0 : _fields$taxonomies$fi.title) || (taxonomy === null || taxonomy === void 0 ? void 0 : taxonomy.title)
  }, taxonomiesWithoutLanguage && renderUntranslatedTermsWarning(), /*#__PURE__*/_react.default.createElement(_antd.PageHeader, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    children: "Add",
    onClick: function onClick() {
      return handleOpenDialog();
    },
    type: "primary",
    disabled: !taxonomy
  })), !taxonomy && /*#__PURE__*/_react.default.createElement(_antd.Alert, {
    message: "Unknown taxonomy",
    description: "Restart the development process or sync new data now",
    type: "info",
    showIcon: true,
    action: /*#__PURE__*/_react.default.createElement(_antd.Button, {
      size: "small",
      type: "ghost",
      onClick: handleSync,
      loading: (loading === null || loading === void 0 ? void 0 : loading.action) === 'syncing'
    }, "Sync to WordPress")
  }), /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 8
  }, treeTerms && treeTerms.map(function (item) {
    return renderTerm(item, 0);
  })));
};

var _default = Taxonomy;
exports.default = _default;